import IconCode from "../iconCode";

export const SALUTE = [
    { value: "Mr", label: "Mr" },
    { value: "Mrs", label: "Mrs" },
    { value: "Ms", label: "Ms" },
    { value: "Dr", label: "Dr" },
    { value: "Baby", label: "Baby" },
    { value: "Master", label: "Master" },
];

export const GENDER = [
    { value: "M", label: "Male" },
    { value: "F", label: "Female" },
    { value: "B", label: "Other" },
];

export const FLOORTYPE = [
    { value: "floor", label: "Floor" },
    { value: "apartments", label: "Apartments" },
    { value: "suite", label: "suite" },
];

export const LANDMARKTYPE = [
    { value: "near", label: "Near" },
    { value: "opposite", label: "Opposite" },
];

export const WHYCHOOSEUS = [
    {
        title: "Fast & Accurate Results",
        description:
            "Quick sample collection and precise reports, delivered on time.",
        icon: IconCode.bolt,
        id: 1,
    },
    {
        title: "Trusted & Ethical",
        description:
            "Committed to transparency, integrity, and patient-first practices.",
        icon: IconCode.trusted,
        id: 2,
    },
    {
        title: "Affordable",
        description: "Quality diagnostics made easy on your pocket.",
        icon: IconCode.rupeeSolidCircle,
        id: 3,
    },
    {
        title: "World Class Technology",
        description: "Advanced systems ensuring precision and reliability.",
        icon: IconCode.globeAsia,
        id: 4,
    },
    {
        title: "Skillfull & Talented Team",
        description:
            "Experienced professionals dedicated to accurate diagnosis.",
        icon: IconCode.arrowUpCircle,
        id: 5,
    },
    {
        title: "One Stop Hub",
        description: "Comprehensive testing solutions under one roof.",
        icon: IconCode.onsStopHub,
        id: 6,
    },
    // {
    //     title: "More Than 1 Million Patients Satisfied",
    //     description:
    //         "Get your blood tests done at home and get reports online.",
    //     icon: "heroicons:cloud-arrow-up",
    //     id: 7,
    // },
];

export const RESPONSIVEMENU = {
    menu: {
        items: [
            {
                name: "Login / SignUp",
                url: "/login",
                fontIcon: IconCode.userProfile,
                children: [],
            },
            {
                name: "Download & Track Reports",
                url: "/login",
                fontIcon: IconCode.eye,
            },
            {
                name: "Quick Download Report",
                url: "/online-reports", //Can be changed to login when redirection completed
                fontIcon: IconCode.reportDownload,
            },
            {
                name: "Find Centres Nearby",
                url: "/locate-us",
                fontIcon: IconCode.navigationArrowCircle,
                children: [],
            },
            {
                name: "Find Tests",
                url: "/facilities",
                fontIcon: IconCode.searchAdd,
                children: [
                    {
                        name: "Find A Test",
                        url: "/find-a-test",
                        fontIcon: IconCode.labMarker1,
                    },
                    {
                        name: "Facilities",
                        url: "/facilities",
                        fontIcon: IconCode.labMarker2,
                    },
                    {
                        name: "Health Checkup",
                        url: "/health-packages",
                        fontIcon: IconCode.healthPackage,
                    },
                    {
                        name: "Book PET-CT Scan",
                        url: "https://hodlab.com/PET-CT",
                        fontIcon: IconCode.reportTat,
                    },
                ],
            },
            {
                name: "Reach Us",
                url: "",
                fontIcon: "",
                children: [
                    {
                        name: "Chat with Us",
                        url: "https://link.hod.care/whatsapp",
                        fontIcon: IconCode.whatsapp,
                    },
                    {
                        name: "Contact Us",
                        url: "/contact-us",
                        fontIcon: IconCode.mail,
                    },
                    {
                        name: "Franchisee Enquiry",
                        url: "/franchise",
                        fontIcon: IconCode.handshake,
                    },
                ],
            },
            {
                name: "Blog",
                url: "https://www.hod.care/blog",
                fontIcon: IconCode.blogger,
                children: [],
            },
        ],
    },
};
export const RESPONSIVEMENULOGGEDIN = {
    menu: {
        items: [
            {
                name: "My Account",
                url: "/my-orders",
                fontIcon: IconCode.accountSetting,
                children: [
                    {
                        name: "My Orders",
                        url: "/my-account/my-orders",
                        fontIcon: IconCode.invoice,
                        children: [],
                    },
                    {
                        name: "My Reports",
                        url: "/my-account/my-orders",
                        fontIcon: IconCode.reportDownload,
                        children: [],
                    },
                    {
                        name: "Manage Family Members",
                        url: "/my-account/members",
                        fontIcon: IconCode.team,
                        children: [],
                    },
                    {
                        name: "Manage Address",
                        url: "/my-account/address",
                        fontIcon: IconCode.directionTo,
                        children: [],
                    },
                    {
                        name: "Health Graphs",
                        url: "/my-account/health-graph",
                        fontIcon: IconCode.trendingUp,
                        children: [],
                    },
                    {
                        name: "View Tickets",
                        url: "/my-account/view-tickets",
                        fontIcon: IconCode.ticket,
                        children: [],
                    },
                ],
            },
            {
                name: "Find Centres",
                url: "/locate-us",
                fontIcon: IconCode.navigationArrowCircle,
                children: [],
            },
            {
                name: "Find Tests",
                url: "/facilities",
                fontIcon: IconCode.searchAdd,
                children: [
                    {
                        name: "Find A Test",
                        url: "/find-a-test",
                        fontIcon: IconCode.labMarker1,
                    },
                    {
                        name: "Facilities",
                        url: "/facilities",
                        fontIcon: IconCode.labMarker2,
                    },
                    {
                        name: "Health Checkup",
                        url: "/health-packages",
                        fontIcon: IconCode.healthPackage,
                    },
                    {
                        name: "Book PET-CT Scan",
                        url: "https://hodlab.com/PET-CT",
                        fontIcon: IconCode.reportTat,
                    },
                ],
            },
            {
                name: "Reach Us",
                url: "",
                fontIcon: "",
                children: [
                    {
                        name: "Chat with Us",
                        url: "https://link.hod.care/whatsapp",
                        fontIcon: IconCode.whatsapp,
                    },
                    {
                        name: "Contact Us",
                        url: "/contact-us",
                        fontIcon: IconCode.mail,
                    },
                    {
                        name: "Franchisee Enquiry",
                        url: "/franchise",
                        fontIcon: IconCode.handshake,
                    },
                    {
                        name: "Raise a Request",
                        url: "/my-account/raise-a-request",
                        fontIcon: IconCode.raise,
                    },
                ],
            },
            {
                name: "Blog",
                url: "https://www.hod.care/blog",
                fontIcon: IconCode.blogger,
                children: [],
            },
        ],
    },
};
